import page0 from "./page0";
import page1 from "./page1";
import page2 from "./page2";
import page3 from "./page3";
import page4 from "./page4";
import page5 from "./page5";
import page6 from "./page6";
import page7 from "./page7";
import page8 from "./page8";
import page9 from "./page9";
import page10 from "./page10";
import page11 from "./page11";
import page12 from "./page12";
import page13 from "./page13";
import page14 from "./page14";
import page15 from "./page15";
import page16 from "./page16";
import page17 from "./page17";
import page18 from "./page18";


export default {
  pages: [
    page0,
    page1,
    page2,
    page3,
    page4,
    page5,
    page6,
    page7,
    page8,
    page9,
    page10,
    page11,
    page12,
    page13,
    page14,
    page15,
    page16,
    page17,
    page18
  ]
};



// WEBPACK FOOTER //
// ./src/config/pollConfig.js